// 判断环境,是否安卓,苹果,微信,APP内外
// https://wiki.didapinche.com/index.php?title=User-Agent_定义
function getEnv() {
    const { userAgent } = window.navigator; // DidaPinche/8.13.5
    const host = window.location.host;
    const versionRes = userAgent.match(/DidaPinche\/(\d+\.\d+\.\d+)/);
    const option = {
        inApplication: userAgent.indexOf('DidaPinche') !== -1, // 在端上
        inWechat: userAgent.indexOf('MicroMessenger') !== -1, // 在微信内部
        isiPhone:  !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),  // 
        isAndroid: userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1,
        isAlipay: userAgent.indexOf('Alipay') !== -1,
        isEnVlocal: /[0-9(localhost)\.]*:/.test(host),  // 本地
        isEnvTest: /(^[a-zA-Z0-9-]*-test)\.(didapinche|didachuxing|didataxi)\.com/.test(host),
        isEnvECS: /(^[a-zA-Z0-9-]*-(simu|ecs))\.(didapinche|didachuxing|didataxi)\.com/.test(host), // 仿真环境
        curAppVersion: versionRes && versionRes[1] // 版本
    };
    option.isDidaPinche = option.inApplication && userAgent.indexOf('[App]') > -1
    option.isDidaTaxi = option.inApplication && !option.isDidaPinche
    option.isEnvOnline = !option.isEnVlocal && !option.isEnvTest && !option.isEnvECS // 线上环境
    return option;
}

export default getEnv()